import React, { PropsWithChildren } from "react";
import classNames from "classnames";
import styles from "./index.module.less";

export function TabName(
  props: PropsWithChildren<{
    active: boolean;
    onClick: (e: React.MouseEvent) => void;
  }>
) {
  return (
    <div
      className={classNames(styles.tabName, props.active ? styles.active : "")}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
}
